import React from 'react';
import { Card, Button, Typography, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout';

const { Title, Paragraph } = Typography;

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();

  const cardStyle = {
    width: '100%',
    maxWidth: 800,
    borderRadius: 16,
    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
  };

  return (
    <AuthLayout>
      <Card
        style={cardStyle}
        bodyStyle={{ padding: 32 }}
        title={
          <Space>
            <Button
              type="text"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/login')}
              style={{ padding: 0, marginRight: 8 }}
            />
            <Title level={3} style={{ margin: 0 }}>
              Política de Privacidad
            </Title>
          </Space>
        }
      >
        <div style={{ lineHeight: 1.8, color: '#262626' }}>
          <Paragraph style={{ marginBottom: 24 }}>
            GRUPO GAYAZU S.A. DE C.V., empresa legalmente constituida de conformidad con las leyes mexicanas, con domicilio en Av. Pedro Infante #5854 LOCAL #39 y 40, Col. Mirador de las Mitras C.P. 64348 en la ciudad de Monterrey, Estado de Nuevo León, en cumplimiento con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP), y como propietaria de CHIF– Community Healthy Inside Fitness, pone a disposición de los usuarios el presente Aviso de Privacidad, con el fin de informarles la manera en que se recaban, utilizan, almacenan, transfieren y protegen los datos personales obtenidos a través de la aplicación móvil y los medios electrónicos asociados.
          </Paragraph>

          <Title level={4} style={{ marginTop: 24, marginBottom: 12 }}>Datos personales recabados</Title>
          <Paragraph style={{ marginBottom: 16 }}>
            CHIF podrá recabar datos personales de identificación, contacto, información demográfica y, en su caso, datos relacionados con el estado físico o hábitos de entrenamiento de los usuarios.
          </Paragraph>

          <Title level={4} style={{ marginTop: 24, marginBottom: 12 }}>Finalidades primarias</Title>
          <Paragraph style={{ marginBottom: 16 }}>
            Estos datos serán utilizados exclusivamente para las siguientes finalidades primarias:
          </Paragraph>
          <Paragraph style={{ marginBottom: 16, paddingLeft: 16 }}>
            (a) Gestionar el registro y autenticación de usuarios;<br />
            (b) Diseñar y ofrecer rutinas personalizadas de entrenamiento;<br />
            (c) Administrar suscripciones y pagos;<br />
            (d) Emitir comprobantes fiscales cuando aplique;<br />
            (e) Brindar atención al cliente y soporte técnico.
          </Paragraph>

          <Title level={4} style={{ marginTop: 24, marginBottom: 12 }}>Finalidades secundarias</Title>
          <Paragraph style={{ marginBottom: 16 }}>
            De forma adicional, y siempre con el consentimiento del usuario, CHIF podrá utilizar la información para finalidades secundarias como: envío de promociones, actualizaciones de servicios, encuestas de satisfacción, o materiales informativos relacionados con el acondicionamiento físico y bienestar.
          </Paragraph>

          <Title level={4} style={{ marginTop: 24, marginBottom: 12 }}>Protección de datos personales</Title>
          <Paragraph style={{ marginBottom: 16 }}>
            Grupo Gayazu S.A. de C.V. se compromete a implementar medidas administrativas, técnicas y físicas necesarias para proteger los datos personales contra daño, pérdida, alteración, destrucción o uso no autorizado. Los datos personales no serán compartidos con terceros sin el consentimiento expreso del titular, salvo en los casos previstos por la ley o cuando sean requeridos por autoridad competente.
          </Paragraph>

          <Title level={4} style={{ marginTop: 24, marginBottom: 12 }}>Derechos ARCO</Title>
          <Paragraph style={{ marginBottom: 16 }}>
            Los usuarios podrán ejercer sus derechos ARCO (Acceso, Rectificación, Cancelación y Oposición), así como revocar su consentimiento para el tratamiento de sus datos, mediante solicitud enviada al correo electrónico <strong>privacidad@chif.mx</strong>, acompañada de los documentos que acrediten su identidad o la representación legal correspondiente.
          </Paragraph>

          <Title level={4} style={{ marginTop: 24, marginBottom: 12 }}>Conservación y modificaciones</Title>
          <Paragraph style={{ marginBottom: 16 }}>
            La información proporcionada será conservada durante el tiempo que sea necesario para cumplir con las finalidades descritas en este aviso, o conforme a los plazos establecidos por la normatividad aplicable. Grupo Gayazu S.A. de C.V. podrá modificar el presente Aviso de Privacidad en cualquier momento, publicando las actualizaciones dentro de la aplicación o en el sitio web oficial de CHIF, considerándose aceptadas dichas modificaciones al continuar utilizando la plataforma.
          </Paragraph>
        </div>

        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <Button
            type="primary"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/login')}
            size="large"
          >
            Regresar al Login
          </Button>
        </div>
      </Card>
    </AuthLayout>
  );
}

